import { render, staticRenderFns } from "./ProductLinks.vue?vue&type=template&id=3748f8cb&scoped=true&"
import script from "./ProductLinks.vue?vue&type=script&lang=js&"
export * from "./ProductLinks.vue?vue&type=script&lang=js&"
import style0 from "./ProductLinks.vue?vue&type=style&index=0&id=3748f8cb&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3748f8cb",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/app/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('3748f8cb')) {
      api.createRecord('3748f8cb', component.options)
    } else {
      api.reload('3748f8cb', component.options)
    }
    module.hot.accept("./ProductLinks.vue?vue&type=template&id=3748f8cb&scoped=true&", function () {
      api.rerender('3748f8cb', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/themes/default/components/core/ProductLinks.vue"
export default component.exports